export default "/unterm2/js/webpack/webfonts/logo-ar.svg";